import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export const WhatsAppButton = ({ phone }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={waLink(undefined, phone)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-btn"
          aria-label="Contactar por WhatsApp"
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-5 right-5 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full bg-glg-green text-white shadow-lg shadow-glg-green/30 sm:h-14 sm:w-14"
        >
          <MessageCircle className="h-5 w-5 sm:h-6 sm:w-6" />
        </motion.a>
      )}
    </AnimatePresence>
  );
};
